import {
    type BaseTextFieldProps,
    InputProps,
    SxProps,
    TextField,
} from '@mui/material'
import { type ChangeEvent, type FC, forwardRef } from 'react'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { getPxAsRem } from 'shared/utils'

interface NonFormikPhoneInputProps extends BaseTextFieldProps {
    disabled?: boolean
    error?: boolean
    label: string
    value?: string
    id?: string
    size?: 'small' | 'medium'
    placeholder?: string
    sx?: SxProps
    InputProps?: InputProps
    handleInputChange: (e: ChangeEvent<HTMLInputElement> | any) => void
}

const PhoneInputWithDefaultCountry = forwardRef((props: any, ref) => {
    return <PhoneInput defaultCountry="US" {...props} ref={ref} name="phone" />
})

const NonFormikPhoneInput: FC<NonFormikPhoneInputProps> = ({
    id,
    size,
    placeholder,
    label,
    error,
    helperText,
    disabled,
    value,
    handleInputChange,
    sx,
    InputProps,
    ...props
}) => {
    return (
        <TextField
            {...props}
            id={id}
            size={size}
            placeholder={placeholder}
            label={label}
            value={value}
            onChange={handleInputChange}
            fullWidth
            disabled={disabled}
            error={error}
            helperText={helperText}
            sx={{
                '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
                    paddingLeft: getPxAsRem(42),
                },
                ...sx,
            }}
            InputProps={{
                inputComponent: PhoneInputWithDefaultCountry,
                ...InputProps,
            }}
            inputProps={{
                defaultCountry: 'US',
                sx: {
                    display: 'flex',
                    height: '100%',
                    border: 'none',
                    '.PhoneInputInput': {
                        outline: 'none',
                        height: '100%',
                        border: 'none',
                        font: 'inherit',
                        color: 'inherit',
                        letterSpacing: 'inherit',
                        '&:-webkit-autofill': {
                            WebkitBoxShadow: '0 0 0 100px #fff inset',
                        },
                    },
                },
            }}
        />
    )
}

export default NonFormikPhoneInput
